// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__U5djU","tyre":"style_tyre__LzqxR"};